module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MD-5be39de021f33d71910dec4b208b6013.png";